
import popovers from './inits/popovers';
import navSlide from './inits/navSlide';
import ajaxModals from './inits/ajaxModals';
import upButton from './inits/upButton';

const AllModules = [
	'popovers',
	'nav-slide',
	'ajax-modals',
	'up-button',
];

export default function(modules = AllModules, context = document.body, options ={}) {

	modules.forEach(module => {
		switch (module) {
			case 'popovers':
				popovers(context);
				break;
			case 'nav-slide':
				navSlide(context);
				break;
			case 'ajax-modals':
				ajaxModals(context);
				break;
			case 'up-button':
				upButton(context);
				break;
		}
	})
}
